import { useState, useEffect, useRef } from 'react';

// Returns { online, syncing } — `syncing` is true for a few seconds
// immediately after the network reconnects, so the UI can show a
// "syncing pending writes" banner while Firestore flushes its offline queue.
export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  const [syncing, setSyncing] = useState(false);
  const wasOfflineRef = useRef(!navigator.onLine);
  const syncTimerRef = useRef(null);

  useEffect(() => {
    const on = () => {
      setOnline(true);
      if (wasOfflineRef.current) {
        setSyncing(true);
        if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
        syncTimerRef.current = setTimeout(() => setSyncing(false), 3500);
      }
      wasOfflineRef.current = false;
    };
    const off = () => {
      setOnline(false);
      setSyncing(false);
      wasOfflineRef.current = true;
      if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
    };
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
      if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
    };
  }, []);

  return { online, syncing };
}
